// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AddToList from "@awc/XDL/Icons/AddToList";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { createLinkIconStyles } from "@awc/XDL/Utilities/sharedStyles";
import { productAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import { css } from "styled-components";

productAddToListLinkStyles.link = {
    ...createLinkIconStyles({
        icon: AddToList,
        linkStyles: {
            typographyProps: {
                weight: fontConfig.weight.regular,
            },
            icon: {
                position: "left",
                iconProps: {
                    size: 13,
                    css: css`
                        &,
                        svg {
                            width: 11px;
                        }
                    `,
                },
            },
        },
    }),
};
